var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7278 12.7814L16.804 15.8577C17.0653 16.119 17.0653 16.5427 16.804 16.804C16.5427 17.0653 16.119 17.0653 15.8577 16.804L12.7814 13.7278C11.7512 14.5519 10.4443 15.0447 9.02236 15.0447C5.6963 15.0447 3 12.3484 3 9.02236C3 5.6963 5.6963 3 9.02236 3C12.3484 3 15.0447 5.6963 15.0447 9.02236C15.0447 10.4443 14.5519 11.7512 13.7278 12.7814ZM9.02236 13.7064C11.6093 13.7064 13.7064 11.6093 13.7064 9.02236C13.7064 6.43543 11.6093 4.3383 9.02236 4.3383C6.43543 4.3383 4.3383 6.43543 4.3383 9.02236C4.3383 11.6093 6.43543 13.7064 9.02236 13.7064Z",
    fill: "#25445D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.77101f3637586b7634365f9fc42e00c3.svg";
export { ForwardRef as ReactComponent };